import api from './api';

export const fetchBanners = async (params = {}) => {
  const response = await api.get('/admin/core/banners/', { params });
  return response.data;
};

export const createBanner = async (formData) => {
  const response = await api.post('/admin/core/banners/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateBanner = async (bannerId, formData, isPartial = true) => {
  const method = isPartial ? 'patch' : 'put';
  const response = await api[method](`/admin/core/banners/${bannerId}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteBanner = async (bannerId) => {
  const response = await api.delete(`/admin/core/banners/${bannerId}/`);
  return response.data;
};

export const toggleBanner = async (bannerId, payload = {}) => {
  const response = await api.post(`/admin/core/banners/${bannerId}/toggle/`, payload);
  return response.data;
};


